import { Record } from 'immutable';

export const getInitialState = <T extends object>(defaultValues: T) => {
  return Record<T>(defaultValues)();
};
